// ═══════════════════════════════════════════════════════════════
// Rince Waterhardheid Kaart NL + BE
// Hergebruikt data uit rince-waterchecker.js (window._HX_G & ._HX_bePC)
// Outlines: Natural Earth 10m (public domain), geprojecteerd naar 480×640
// ═══════════════════════════════════════════════════════════════

(function () {
'use strict';

// ─── PROJECTIE ──────────────────────────────────────────────
// Lineaire projectie op een viewBox van 480 × 640.
// MIN/MAX-bounds zijn afgestemd op de Natural Earth path data hieronder —
// niet wijzigen zonder ook de paths opnieuw te genereren.
const W = 480, H = 640;
const MIN_LNG = 2.40, MAX_LNG = 7.25;
const MIN_LAT = 49.50, MAX_LAT = 53.55;

function project(lat, lng) {
  return [
    ((lng - MIN_LNG) / (MAX_LNG - MIN_LNG)) * W,
    ((MAX_LAT - lat) / (MAX_LAT - MIN_LAT)) * H
  ];
}

// ─── STEDEN ─────────────────────────────────────────────────
// `g` = gemeentenaam in window._HX_G (NL)
// `pc` = postcode in window._HX_bePC (BE)
const NL_CITIES = [
  { n: 'Den Helder',   g: 'Den Helder',         lat: 52.96, lng: 4.76 },
  { n: 'Alkmaar',      g: 'Alkmaar',            lat: 52.63, lng: 4.75 },
  { n: 'Haarlem',      g: 'Haarlem',            lat: 52.39, lng: 4.64 },
  { n: 'Amsterdam',    g: 'Amsterdam',          lat: 52.37, lng: 4.89 },
  { n: 'Almere',       g: 'Almere',             lat: 52.37, lng: 5.21 },
  { n: 'Lelystad',     g: 'Lelystad',           lat: 52.51, lng: 5.47 },
  { n: 'Hilversum',    g: 'Hilversum',          lat: 52.22, lng: 5.18 },
  { n: 'Utrecht',      g: 'Utrecht',            lat: 52.09, lng: 5.12 },
  { n: 'Amersfoort',   g: 'Amersfoort',         lat: 52.16, lng: 5.39 },
  { n: 'Apeldoorn',    g: 'Apeldoorn',          lat: 52.21, lng: 5.97 },
  { n: 'Deventer',     g: 'Deventer',           lat: 52.26, lng: 6.16 },
  { n: 'Zwolle',       g: 'Zwolle',             lat: 52.51, lng: 6.09 },
  { n: 'Leeuwarden',   g: 'Leeuwarden',         lat: 53.20, lng: 5.79 },
  { n: 'Groningen',    g: 'Groningen',          lat: 53.22, lng: 6.57 },
  { n: 'Assen',        g: 'Assen',              lat: 52.99, lng: 6.56 },
  { n: 'Emmen',        g: 'Emmen',              lat: 52.78, lng: 6.91 },
  { n: 'Enschede',     g: 'Enschede',           lat: 52.22, lng: 6.89 },
  { n: 'Arnhem',       g: 'Arnhem',             lat: 51.98, lng: 5.91 },
  { n: 'Nijmegen',     g: 'Nijmegen',           lat: 51.84, lng: 5.86 },
  { n: 'Den Haag',     g: 'Den Haag',           lat: 52.07, lng: 4.30 },
  { n: 'Leiden',       g: 'Leiden',             lat: 52.16, lng: 4.49 },
  { n: 'Delft',        g: 'Delft',              lat: 52.01, lng: 4.36 },
  { n: 'Rotterdam',    g: 'Rotterdam',          lat: 51.92, lng: 4.48 },
  { n: 'Zoetermeer',   g: 'Zoetermeer',         lat: 52.06, lng: 4.49 },
  { n: 'Dordrecht',    g: 'Dordrecht',          lat: 51.81, lng: 4.69 },
  { n: 'Middelburg',   g: 'Middelburg',         lat: 51.50, lng: 3.61 },
  { n: 'Breda',        g: 'Breda',              lat: 51.57, lng: 4.77 },
  { n: 'Tilburg',      g: 'Tilburg',            lat: 51.56, lng: 5.07 },
  { n: 'Den Bosch',    g: "'s-Hertogenbosch",   lat: 51.69, lng: 5.30 },
  { n: 'Eindhoven',    g: 'Eindhoven',          lat: 51.44, lng: 5.48 },
  { n: 'Venlo',        g: 'Venlo',              lat: 51.37, lng: 6.17 },
  { n: 'Maastricht',   g: 'Maastricht',         lat: 50.85, lng: 5.69 },
  { n: 'Heerlen',      g: 'Heerlen',            lat: 50.89, lng: 5.98 }
];

const BE_CITIES = [
  { n: 'Oostende',      pc: '8400', lat: 51.23, lng: 2.92 },
  { n: 'Brugge',        pc: '8000', lat: 51.21, lng: 3.22 },
  { n: 'Roeselare',     pc: '8800', lat: 50.95, lng: 3.12 },
  { n: 'Kortrijk',      pc: '8500', lat: 50.83, lng: 3.27 },
  { n: 'Doornik',       pc: '7500', lat: 50.61, lng: 3.39 },
  { n: 'Gent',          pc: '9000', lat: 51.05, lng: 3.73 },
  { n: 'Sint-Niklaas',  pc: '9100', lat: 51.16, lng: 4.14 },
  { n: 'Aalst',         pc: '9300', lat: 50.94, lng: 4.04 },
  { n: 'Antwerpen',     pc: '2000', lat: 51.22, lng: 4.40 },
  { n: 'Mechelen',      pc: '2800', lat: 51.03, lng: 4.48 },
  { n: 'Brussel',       pc: '1000', lat: 50.85, lng: 4.35 },
  { n: 'Leuven',        pc: '3000', lat: 50.88, lng: 4.70 },
  { n: 'Bergen',        pc: '7000', lat: 50.45, lng: 3.95 },
  { n: 'Charleroi',     pc: '6000', lat: 50.41, lng: 4.44 },
  { n: 'Namen',         pc: '5000', lat: 50.47, lng: 4.87 },
  { n: 'Hasselt',       pc: '3500', lat: 50.93, lng: 5.34 },
  { n: 'Genk',          pc: '3600', lat: 50.97, lng: 5.50 },
  { n: 'Luik',          pc: '4000', lat: 50.63, lng: 5.57 },
  { n: 'Verviers',      pc: '4800', lat: 50.59, lng: 5.86 },
  { n: 'Arlon',         pc: '6700', lat: 49.68, lng: 5.81 }
];

// ─── PATHS (Natural Earth 10m, vereenvoudigd, geprojecteerd) ────
// NL MAINLAND (1 polygon, projected to viewBox 480x640)
const NL_MAINLAND_PATH = "M474.5 48.2L474.6 57.7L472.3 65.2L473.6 70.3L474.3 87.2L473.4 92.3L471.3 97.6L463.2 109.9L461.4 114.7L458.9 142.6L457.1 146.0L452.1 144.3L447.2 145.0L441.9 143.5L432.5 143.6L429.2 144.6L425.7 147.1L426.6 148.8L426.0 152.8L429.9 156.5L422.8 159.3L424.0 161.8L425.1 169.8L427.0 172.0L429.6 173.2L437.5 174.3L445.4 176.7L450.5 175.8L452.6 173.6L458.6 183.2L460.0 187.2L459.2 193.0L456.5 199.9L456.4 202.8L457.9 208.5L453.5 211.1L448.1 217.8L443.9 219.6L438.5 227.1L432.1 227.8L430.5 228.7L426.7 234.3L423.6 235.4L422.9 237.0L423.1 239.4L433.3 244.7L436.4 248.2L436.5 251.2L434.5 252.7L429.9 259.4L427.2 260.9L418.5 261.1L408.6 264.5L402.1 268.9L393.7 267.0L394.6 270.6L394.1 272.2L390.4 273.2L390.1 270.7L384.7 269.2L382.5 266.1L378.6 266.7L368.9 261.3L365.5 263.1L371.7 269.9L364.6 268.1L349.5 274.1L349.2 275.5L351.4 277.2L352.7 280.2L352.6 283.4L350.4 285.6L350.3 287.3L354.1 287.6L357.5 289.8L358.5 290.8L357.1 295.3L359.4 298.2L366.1 301.1L364.4 306.9L364.8 308.9L375.4 322.5L376.6 330.5L375.4 339.9L376.9 341.7L375.4 348.5L370.9 352.7L362.7 366.4L361.9 369.5L361.6 373.0L362.3 376.0L364.6 377.3L369.6 373.9L371.8 374.6L368.8 377.0L370.9 378.9L369.4 380.9L363.8 383.9L354.6 391.2L350.1 398.1L348.3 398.3L344.5 394.7L341.7 396.2L343.8 404.5L343.9 408.4L349.1 406.5L353.1 407.5L356.7 407.1L355.9 410.6L356.3 414.1L359.4 416.4L362.6 417.6L361.7 420.1L362.5 423.4L361.9 426.2L360.8 427.6L358.6 427.4L357.2 428.2L356.3 429.8L356.1 434.5L354.7 435.8L353.2 435.4L353.6 437.4L356.0 440.4L355.8 442.5L335.8 442.1L331.8 438.8L329.4 441.8L327.2 441.8L325.4 440.8L326.6 435.3L320.7 432.2L319.1 429.8L318.9 426.2L326.0 418.2L328.8 416.9L332.9 409.4L331.0 408.8L328.8 409.4L334.3 399.2L332.9 397.4L333.7 393.8L334.5 393.3L335.6 394.3L336.4 393.2L337.7 390.0L337.0 387.7L339.1 387.6L341.0 386.6L338.8 384.2L339.1 382.4L340.5 381.0L339.4 378.2L334.7 378.9L329.7 373.9L322.5 374.7L319.2 371.8L313.6 370.1L311.3 368.2L310.3 361.6L308.5 359.2L306.1 357.7L304.0 357.4L295.8 362.1L278.6 362.1L278.6 356.5L276.8 354.2L271.2 354.4L269.5 353.4L267.5 347.5L264.1 343.8L263.4 342.2L263.8 338.8L265.2 333.7L263.3 330.0L260.0 327.6L258.5 328.0L256.9 332.4L253.1 338.0L250.6 340.4L248.4 341.0L242.8 338.8L235.9 338.5L233.8 337.6L234.3 335.7L235.5 335.6L239.8 337.6L239.1 334.8L240.1 330.2L239.9 327.8L238.9 326.5L235.4 324.7L234.0 324.5L230.7 326.2L223.1 335.6L220.7 336.9L216.0 336.2L211.9 336.6L210.0 335.2L211.1 329.1L210.3 327.8L206.2 328.0L200.9 330.0L195.7 333.0L196.9 334.3L196.0 338.2L199.5 343.9L199.0 346.6L197.2 347.6L192.6 347.3L187.1 344.7L184.2 344.6L183.0 342.2L182.6 337.5L181.6 336.7L180.4 338.3L178.2 338.9L169.3 338.7L165.3 336.7L158.2 331.4L154.1 330.9L152.7 331.8L148.7 339.0L141.2 341.2L137.5 337.8L131.5 334.9L127.6 331.2L119.8 332.6L112.4 330.4L108.4 323.8L105.1 321.0L103.6 316.7L104.7 315.2L114.8 309.0L141.4 306.1L145.1 307.3L148.1 310.7L149.0 313.0L145.6 315.2L145.6 316.1L155.1 317.1L159.9 319.1L164.0 322.6L168.7 332.5L171.1 333.2L176.2 332.5L178.2 333.5L186.4 332.2L187.7 328.6L186.9 325.2L184.8 322.6L182.1 321.0L177.6 320.2L173.5 318.4L167.4 318.4L157.2 309.7L165.1 306.5L173.9 306.9L176.5 307.7L178.9 309.7L178.4 306.7L177.1 305.5L171.8 304.9L169.5 301.9L169.5 297.0L172.5 294.9L175.9 294.6L172.3 291.7L165.4 289.6L164.0 287.6L163.4 282.3L161.7 279.0L156.5 275.0L154.6 276.4L145.6 278.4L144.7 274.0L147.6 272.1L153.8 270.2L154.7 269.1L159.9 269.7L163.1 271.2L166.0 269.7L161.5 263.6L161.5 261.4L162.7 259.4L159.3 248.1L159.9 246.9L160.6 245.8L165.2 246.8L169.0 246.2L172.4 244.1L186.5 227.1L198.6 209.6L208.6 191.8L214.6 174.6L215.5 168.9L217.4 164.9L221.6 134.2L224.6 119.1L228.8 108.5L230.2 96.7L231.0 93.4L232.1 92.0L238.2 92.9L239.2 92.0L239.9 93.2L238.5 98.0L240.8 100.9L244.8 102.1L248.7 101.8L255.2 97.1L261.2 95.8L265.1 94.2L288.3 73.8L292.8 72.8L294.9 71.5L296.9 67.6L299.6 56.8L301.6 52.0L307.2 46.3L310.9 44.8L315.9 39.1L322.6 37.6L326.1 34.8L341.9 28.6L345.5 26.2L347.8 26.0L354.4 22.7L383.4 21.7L387.1 23.9L390.5 21.7L405.2 17.6L428.6 14.1L438.3 15.7L442.1 18.3L445.4 31.3L450.2 35.4L457.2 38.5L459.0 38.0L461.0 39.2L463.7 38.0L463.7 39.1L462.5 40.2L463.2 44.8L466.3 46.4L474.5 48.2Z";

// NL ISLANDS (8 polygons — Wadden + Zeeland)
const NL_ISLAND_PATHS = [
  "M94.0 343.7L113.0 337.1L119.2 341.2L128.9 343.9L134.2 347.6L138.2 347.6L141.9 348.7L144.3 348.4L154.0 344.2L155.3 342.7L156.8 338.1L161.2 339.1L162.7 340.0L165.3 344.4L170.4 346.2L173.8 346.5L176.2 343.3L180.3 344.8L178.9 350.7L175.0 356.1L170.1 359.9L157.9 366.1L153.3 369.7L151.1 370.4L139.4 370.5L136.7 368.2L136.2 362.7L134.3 361.5L119.7 357.1L110.3 358.6L109.2 359.7L109.0 365.0L104.3 365.7L101.1 365.4L98.1 364.0L95.7 361.3L94.3 357.4L94.8 349.8L94.0 343.7Z",
  "M162.0 294.6L166.1 295.7L168.0 297.0L168.2 299.6L167.2 301.2L163.8 303.0L154.4 304.4L148.6 301.5L147.0 297.3L141.6 294.6L139.5 292.4L138.2 292.3L135.1 295.8L128.7 295.4L127.3 293.5L127.6 288.4L131.2 286.1L140.0 284.7L142.9 285.6L152.4 285.8L156.2 287.6L162.0 294.6Z",
  "M246.7 69.4L246.7 70.4L248.7 70.4L246.7 74.9L244.0 79.0L239.3 82.7L237.1 86.9L233.8 87.8L230.3 86.4L228.4 82.4L229.0 78.3L231.0 73.6L233.4 69.8L238.1 65.9L242.9 57.2L246.0 57.4L246.4 58.3L246.0 60.6L248.4 65.6L248.4 68.1L246.7 69.4Z",
  "M245.3 52.0L249.5 46.8L256.0 41.1L262.7 37.3L267.7 38.0L267.7 39.1L265.1 39.1L260.9 40.8L248.4 53.3L245.3 52.0Z",
  "M299.2 18.9L300.6 17.9L315.2 15.2L312.9 18.3L310.1 19.2L304.4 19.4L305.0 21.7L303.7 22.4L299.6 22.7L277.9 31.2L275.1 31.1L273.9 28.7L275.0 26.0L280.3 24.2L282.1 22.7L297.6 20.1L299.2 18.9Z",
  "M324.0 13.0L347.8 12.0L351.8 14.1L342.0 16.2L331.8 16.2L324.5 18.9L322.0 18.4L320.3 16.0L320.9 13.7L322.5 12.3L324.0 13.0Z",
  "M377.2 6.5L387.0 5.7L389.8 6.5L389.8 7.6L371.4 12.8L369.5 15.2L368.9 13.7L369.5 13.0L368.4 10.8L370.9 8.7L377.2 6.5Z",
  "M400.0 -1.0L401.3 -1.3L406.8 1.0L405.4 2.2L401.9 1.0L400.1 0.0L400.0 -1.0Z",
];

// BE
const BE_PATH = "M12.1 389.1L17.8 386.4L31.2 376.2L51.8 364.0L71.7 350.9L94.0 343.7L94.8 349.8L94.3 357.4L95.7 361.3L98.1 364.0L101.1 365.4L104.3 365.7L109.0 365.0L109.2 359.7L110.3 358.6L119.7 357.1L134.3 361.5L136.2 362.7L136.7 368.2L139.4 370.5L151.1 370.4L170.1 359.9L175.0 356.1L178.9 350.7L180.3 344.8L182.2 346.6L183.7 351.1L188.3 356.2L188.8 358.1L187.7 360.7L189.7 359.2L191.1 356.2L187.0 354.1L186.4 347.6L184.2 344.6L187.1 344.7L192.6 347.3L197.2 347.6L199.0 346.6L199.5 343.9L196.0 338.2L196.9 334.3L195.7 333.0L200.9 330.0L209.1 327.5L210.3 327.8L211.1 329.1L210.0 335.2L211.9 336.6L216.0 336.2L220.7 336.9L223.1 335.6L230.7 326.2L234.0 324.5L238.9 326.5L239.9 327.8L240.1 330.2L239.1 334.8L239.8 337.6L235.5 335.6L234.3 335.7L233.8 337.6L235.9 338.5L242.8 338.8L248.4 341.0L250.6 340.4L253.1 338.0L256.9 332.4L258.5 328.0L260.0 327.6L263.3 330.0L265.2 333.7L263.8 338.8L263.4 342.2L264.1 343.8L267.5 347.5L269.5 353.4L271.2 354.4L276.8 354.2L278.6 356.5L278.6 362.1L295.8 362.1L304.0 357.4L306.1 357.7L308.5 359.2L310.3 361.6L311.3 368.2L313.6 370.1L319.2 371.8L322.5 374.7L329.7 373.9L334.7 378.9L339.4 378.2L340.5 381.0L339.1 382.4L338.8 384.2L341.0 386.6L339.1 387.6L337.0 387.7L337.7 390.0L336.4 393.2L335.6 394.3L334.5 393.3L333.7 393.8L332.9 397.4L334.3 399.2L328.8 409.4L331.0 408.8L332.9 409.4L328.8 416.9L326.0 418.2L318.9 426.2L319.1 429.8L320.7 432.2L326.6 435.3L325.4 440.8L327.2 441.8L329.4 441.8L331.8 438.8L335.8 442.1L355.8 442.5L355.7 443.6L357.4 444.5L357.4 449.0L364.3 448.2L366.2 450.2L372.2 459.5L370.9 460.4L372.1 462.6L374.1 463.7L380.9 463.9L381.2 464.8L379.3 468.2L374.0 472.2L372.2 475.1L373.8 477.2L373.2 479.1L375.1 479.6L374.4 480.9L376.8 484.1L381.6 482.8L383.5 483.9L389.6 485.0L388.3 487.3L389.1 490.4L391.0 492.5L389.7 502.8L393.2 508.9L393.4 511.1L392.1 512.5L389.5 513.0L385.9 512.2L384.6 513.0L383.0 515.7L383.2 518.7L381.4 520.4L375.1 522.6L371.8 525.8L370.8 527.2L372.1 528.7L372.6 532.2L371.3 534.2L368.5 534.9L367.8 538.0L369.1 539.8L367.9 542.0L366.4 541.3L365.9 537.1L364.6 535.8L360.1 537.5L357.7 536.7L356.1 533.3L354.6 534.6L352.5 534.8L350.5 540.7L343.7 545.7L342.9 550.3L340.2 553.5L340.1 558.1L336.8 560.6L336.6 562.8L337.7 564.5L336.7 566.7L332.9 569.4L328.5 578.2L328.1 579.7L332.4 583.4L329.8 583.1L329.3 585.4L330.2 586.4L329.0 587.2L328.6 588.7L329.3 592.6L330.4 594.4L332.5 595.0L334.4 596.9L336.7 601.6L337.0 604.9L339.6 606.2L341.5 606.2L342.2 608.3L340.7 612.5L341.0 613.7L344.4 615.1L345.0 617.3L339.5 626.9L341.1 627.9L340.2 630.3L337.9 632.9L335.6 634.0L331.2 632.2L327.6 635.1L321.1 633.1L318.7 634.4L316.9 637.8L314.6 637.8L311.5 636.3L304.6 640.8L302.5 640.2L301.8 638.8L301.9 632.8L297.1 623.8L295.3 622.1L290.5 620.1L289.2 622.2L286.8 622.1L286.1 620.0L286.4 617.8L287.6 616.7L287.0 614.3L283.0 609.8L276.4 611.1L274.1 610.4L270.8 607.6L265.4 600.1L259.9 597.8L254.4 593.1L245.9 595.1L243.3 594.7L242.4 593.5L242.4 587.6L241.0 584.2L243.4 578.1L243.5 574.7L241.9 571.8L237.3 569.8L235.9 567.6L240.2 555.3L240.2 550.9L242.1 546.7L243.7 547.7L244.5 541.7L244.6 538.9L243.7 537.7L240.6 538.3L239.5 537.8L239.1 535.5L236.4 536.8L225.8 547.7L225.0 550.5L225.7 553.4L224.9 558.4L223.3 562.7L222.3 563.4L218.1 564.1L204.3 571.2L201.4 571.7L185.8 567.3L178.3 568.4L171.4 564.9L172.2 565.0L171.0 560.1L171.9 557.0L174.5 554.4L179.1 551.5L176.2 540.9L175.2 540.4L172.2 541.5L170.8 540.7L173.5 528.7L175.0 525.8L178.3 522.8L177.9 520.1L174.5 517.9L173.2 518.4L173.3 520.5L172.6 521.2L170.7 520.4L168.0 514.4L163.9 511.3L160.6 507.6L158.7 506.6L150.3 509.6L148.0 509.6L142.5 506.4L134.1 506.3L132.0 507.7L128.3 513.9L124.9 510.5L123.2 490.6L119.6 485.7L115.2 484.1L108.8 484.1L107.6 483.1L108.7 480.1L106.6 478.8L105.2 479.0L101.9 481.7L95.1 483.6L89.1 480.8L86.2 477.7L85.5 470.9L82.1 457.4L83.5 454.8L82.4 451.0L81.6 449.6L78.9 448.9L78.1 448.0L73.9 439.5L72.2 437.9L69.6 437.1L56.6 441.2L52.5 444.6L49.5 449.9L48.2 450.9L38.3 446.7L36.4 445.1L34.0 439.9L30.3 436.3L28.9 433.2L21.8 432.0L20.4 429.1L18.5 427.4L19.5 423.9L17.5 416.9L20.9 412.2L20.6 409.1L15.5 402.8L13.6 392.8L12.1 389.1Z";

// IJsselmeer + Markermeer (Natural Earth)
const IJSSELMEER_PATH = "M343.5 159.6L343.7 165.7L342.5 169.4L336.6 178.1L331.2 182.8L322.0 186.2L319.0 188.6L314.5 193.9L311.3 201.4L310.1 202.6L301.6 204.6L297.4 204.3L293.1 202.3L283.9 195.7L275.3 195.7L268.4 191.6L260.3 190.0L254.2 186.3L255.5 185.2L255.5 184.0L258.2 185.2L258.2 184.0L259.8 185.2L261.4 181.1L264.8 178.5L266.4 175.5L264.8 174.7L262.3 171.1L265.1 170.1L264.3 167.8L266.3 165.8L265.6 161.9L260.9 150.2L260.8 146.2L262.2 143.5L265.7 143.0L268.4 143.9L270.8 146.2L273.7 145.4L279.8 141.7L281.4 139.9L282.7 136.1L287.4 133.2L285.7 126.7L279.1 124.4L276.6 125.1L274.2 127.0L270.8 124.5L269.5 122.4L268.7 108.9L263.8 99.1L261.7 97.4L270.1 93.2L285.8 79.9L294.2 74.8L295.9 79.6L297.8 81.8L298.3 83.8L297.5 87.7L298.9 92.0L298.5 94.6L296.9 96.3L298.2 98.9L293.6 103.5L293.8 106.1L298.0 109.5L307.4 110.5L312.5 112.6L320.4 109.8L328.7 112.6L325.2 113.4L322.3 115.4L317.9 122.4L316.3 133.0L316.5 139.1L322.7 148.3L337.4 148.1L340.5 149.5L341.5 151.2L343.5 159.6Z";

// Total bytes: NL_MAINLAND=4103, NL_ISLANDS=1571, BE=4039, IJSSEL=948

// ─── HELPERS ────────────────────────────────────────────────
function nlHardness(g) {
  const G = window._HX_G;
  if (!G || !G[g]) return null;
  return (G[g][0] + G[g][1]) / 2;
}

function beHardness(pc) {
  const m = window._HX_bePC;
  if (!m || !m[pc]) return null;
  return m[pc].dh;
}

function interp(c1, c2, t) {
  const a = parseInt(c1.slice(1), 16);
  const b = parseInt(c2.slice(1), 16);
  const ar=(a>>16)&255, ag=(a>>8)&255, ab=a&255;
  const br=(b>>16)&255, bg=(b>>8)&255, bb=b&255;
  return 'rgb(' +
    Math.round(ar + (br-ar)*t) + ',' +
    Math.round(ag + (bg-ag)*t) + ',' +
    Math.round(ab + (bb-ab)*t) + ')';
}

// Volgt het gradient van de bar: groen → grijs → tan → rood
function colorFor(dh) {
  if (dh <= 4)  return '#5a8c66';
  if (dh <= 6)  return interp('#5a8c66', '#a8a8a8', (dh-4)/2);
  if (dh <= 8)  return interp('#a8a8a8', '#d49b6e', (dh-6)/2);
  if (dh <= 12) return interp('#d49b6e', '#c4554d', (dh-8)/4);
  return '#c4554d';
}

function esc(s) {
  const d = document.createElement('div');
  d.textContent = String(s);
  return d.innerHTML;
}

// ─── INIT ÉÉN KAART-INSTANCE ────────────────────────────────
function initMap(wrap) {
  const svg = wrap.querySelector('.hx-wc-map-svg');
  const tooltip = wrap.querySelector('.hx-wc-map-tooltip');
  if (!svg || !tooltip) return;

  // Koppel aan de checker in dezelfde sectie
  const section = wrap.closest('.hx-waterchecker');
  const instance = section ? section.querySelector('.hx-wc-instance') : null;
  const input = instance ? instance.querySelector('.hx-wc-input') : null;
  const btn = instance ? instance.querySelector('.hx-wc-btn') : null;

  // Globale index voor stagger-reveal (over NL + BE heen)
  let dotIndex = 0;

  function dotsMarkup(cities, isNL) {
    return cities.map(function (c) {
      const dh = isNL ? nlHardness(c.g) : beHardness(c.pc);
      if (dh == null) return '';
      const xy = project(c.lat, c.lng);
      const cx = xy[0].toFixed(1);
      const cy = xy[1].toFixed(1);
      const color = colorFor(dh);
      const key = isNL ? c.g : c.pc;
      const cc = isNL ? 'NL' : 'BE';
      const labelExtra = isNL ? '' : ' · ' + c.pc;
      const i = dotIndex++;
      return '<g class="hx-wc-dot-group" ' +
        'tabindex="0" role="button" ' +
        'style="--i:' + i + '" ' +
        'data-name="' + esc(c.n + labelExtra) + '" ' +
        'data-dh="' + dh.toFixed(1) + '" ' +
        'data-key="' + esc(key) + '" ' +
        'data-cc="' + cc + '" ' +
        'aria-label="' + esc(c.n + ' — ' + dh.toFixed(1) + ' graden Duits') + '">' +
        '<circle class="hx-wc-hit" cx="' + cx + '" cy="' + cy + '" r="16" fill="transparent"/>' +
        '<circle class="hx-wc-ripple" cx="' + cx + '" cy="' + cy + '" r="5" fill="' + color + '"/>' +
        '<circle class="hx-wc-dot" cx="' + cx + '" cy="' + cy + '" r="5" fill="' + color + '"/>' +
        '</g>';
    }).join('');
  }

  const islandPaths = NL_ISLAND_PATHS
    .map(function (d) { return '<path class="hx-wc-country-outline hx-wc-island" d="' + d + '" />'; })
    .join('');

  svg.innerHTML =
    '<g class="hx-wc-outlines">' +
      '<path class="hx-wc-country-outline" d="' + NL_MAINLAND_PATH + '" />' +
      '<path class="hx-wc-country-outline" d="' + BE_PATH + '" />' +
      islandPaths +
    '</g>' +
    '<g class="hx-wc-water-group">' +
      '<path class="hx-wc-water" d="' + IJSSELMEER_PATH + '" />' +
    '</g>' +
    '<g class="hx-wc-labels">' +
      '<text class="hx-wc-country-label" x="30" y="105">Nederland</text>' +
      '<text class="hx-wc-country-label" x="30" y="475">België</text>' +
    '</g>' +
    '<g class="hx-wc-dots">' +
      dotsMarkup(NL_CITIES, true) +
      dotsMarkup(BE_CITIES, false) +
    '</g>';

  // ─── INTERACTIE ──
  let activeGroup = null;
  const groups = svg.querySelectorAll('.hx-wc-dot-group');

  function showTip(group) {
    const name = group.getAttribute('data-name');
    const dh = group.getAttribute('data-dh');
    const cc = group.getAttribute('data-cc');
    tooltip.querySelector('.hx-wc-tt-name').textContent = name;
    tooltip.querySelector('.hx-wc-tt-val').innerHTML = '<strong>' + dh + '</strong> °dH · ' + cc;

    const dot = group.querySelector('.hx-wc-dot');
    const canvas = svg.parentElement;
    const cRect = canvas.getBoundingClientRect();
    const dRect = dot.getBoundingClientRect();
    tooltip.style.left = (dRect.left + dRect.width / 2 - cRect.left) + 'px';
    tooltip.style.top = (dRect.top - cRect.top) + 'px';
    tooltip.hidden = false;
  }

  function hideTip() { tooltip.hidden = true; }

  function selectDot(group) {
    if (activeGroup) activeGroup.classList.remove('hx-wc-dot-group--active');
    group.classList.add('hx-wc-dot-group--active');
    activeGroup = group;
    if (!input || !btn) return;
    input.value = group.getAttribute('data-key');
    btn.click();
    setTimeout(function () {
      if (instance && typeof instance.scrollIntoView === 'function') {
        instance.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 60);
  }

  groups.forEach(function (g) {
    g.addEventListener('mouseenter', function () { showTip(g); });
    g.addEventListener('focus',      function () { showTip(g); });
    g.addEventListener('mouseleave', hideTip);
    g.addEventListener('blur',       hideTip);
    g.addEventListener('click',      function () { showTip(g); selectDot(g); });
    g.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        selectDot(g);
      }
    });
  });

  // ─── STAGGER REVEAL via IntersectionObserver ──
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          wrap.classList.add('hx-wc-revealed');
          io.disconnect();
        }
      });
    }, { threshold: 0.15 });
    io.observe(wrap);
  } else {
    // Fallback: meteen tonen
    wrap.classList.add('hx-wc-revealed');
  }
}

// ─── WACHT TOT DE CHECKER-DATA GELADEN IS ────────────────────
function whenReady(cb, attempts) {
  attempts = (attempts == null) ? 40 : attempts;
  if (window._HX_G && window._HX_bePC) return cb();
  if (attempts <= 0) {
    console.warn('[rince-map] checker-data niet beschikbaar — is rince-waterchecker.js geladen?');
    return;
  }
  setTimeout(function () { whenReady(cb, attempts - 1); }, 60);
}

function initAll() {
  document.querySelectorAll('[data-hx-wc-map]:not([data-hx-init])').forEach(function (el) {
    el.setAttribute('data-hx-init', '1');
    initMap(el);
  });
}

function go() { whenReady(initAll); }

function lazyGo() {
  var targets = document.querySelectorAll('[data-hx-wc-map], .hx-wc-map-canvas, .hx-wc-map');
  if (!targets.length || !('IntersectionObserver' in window)) { go(); return; }
  var fired = false;
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting && !fired) { fired = true; io.disconnect(); go(); }
    });
  }, { rootMargin: '400px 0px' });
  targets.forEach(function (t) { io.observe(t); });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', lazyGo);
} else {
  lazyGo();
}

})();